
import { Vat } from "@/models/base";
import { VatService } from "@/services/vat-service";
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import AppVatEditModal from "@/components/common/VatEditModal.vue";

export default Vue.extend({
	data(){
		return {
			vats: VatService.getVats(),
			toEditVat: null as null | Vat
		};
	},
	computed: {
		path():IBreadCrumb[] {
			return [{
				to: "/settings/sales", value: this.$ct("sale/purchase")
			},     {value: this.$ct("vat-percentages")}] as IBreadCrumb[];
		},
	},
	methods: {
		edit(vat:Vat){
			this.toEditVat = new Vat(vat.getJSON());
		},
		async remove(vat:Vat){
			let confirmText = this.$ct("are-you-sure-you-want-to-remove-vat-percentage", {percentage: vat.Value});
			let confirm = await this.$wf.confirm(confirmText, this.$ct("common.yes"), this.$ct("common.no"), this.$ct("common.warning"), "warning");
			if (!confirm) return;
			await VatService.deleteVat(vat);
		},
		openCreateNewVatModal(){
			this.toEditVat = new Vat();
		},
		cancel(){
			this.toEditVat = null;
		},
		onVatsRefreshed(){
			this.vats = VatService.getVats();
		}
	},
	created(){
		VatService.on("vats-refreshed", this.onVatsRefreshed);
	},
	destroyed(){
		VatService.off("vats-refreshed", this.onVatsRefreshed);
	},
	components: {
		AppVatEditModal
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
